/* import __COLOCATED_TEMPLATE__ from './date.hbs'; */
import { humanDateFormat } from 'client-portal/utils/date-time';
import Component from '@glimmer/component';

export default class SiteBillingAccountHistoryCellsDate extends Component {
  humanDateFormat = humanDateFormat;

  get dateValue() {
    const item = this.args.item;

    switch (item.constructor.modelName) {
      case 'appointment':
      case 'group-appointment':
        return item.startTime;
      case 'invoice-item':
        return item.issueDate;
      case 'payment':
        return item.paidAt;
      default:
        return null;
    }
  }
}
